export default __webpack_public_path__ + "static/media/proride-kids-1.c60f1607.webp";